import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createSubscriptionTag,
  deleteSubscriptionTag,
  updateSubscriptionTag,
} from '@store/membership/SubscriptionTagReducer'

export const SubscriptionTagForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.subscriptionTag)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createSubscriptionTag(values)).then(() => {
              return true
            }),
          update: async (values) =>
            dispatch(updateSubscriptionTag(values)).then(() => {
              return true
            }),
          delete: async (values) =>
            dispatch(deleteSubscriptionTag(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

SubscriptionTagForm.displayName = 'SubscriptionTagForm'

export default SubscriptionTagForm
